export default __webpack_public_path__ + "static/media/glassbuilding.0dd07eed.png";